import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CMSBlock from "components/cms/CMSBLock";
import api from "api";
export default function PageCMS() {
  const { page } = useParams();
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState(null);
  useEffect(() => {
    loadContent();
  }, [page]);
  const loadContent = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/cms/page-cms-${page}/contents`);
      setPageData(res.data);
    } catch (e) {
      console.error("PageCMS load error:", e);
      setPageData(null);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return <div id="page-cms" className="container my-5" />;
  }
  if (!pageData || !pageData.sections) {
    return null;
  }
  return (
    <div id="page-cms">
      {pageData.sections.map((section, index) => {

        switch (section.type) {
          case "cms_block":
            return (
              <>
                <CMSBlock
                  key={index}
                  blockId={section.blockId}
                  className={section.className}
                />
              </>
            );

          default:
            return null;

        }

      })}
    </div>
  );
}
